import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from '@core/services/store.service';
import { Error } from '@shared/interfaces/error';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.styl'],
})
export class ErrorPageComponent implements OnInit {
  @Input() error: Error;
  urlParams: any = {};
  public viewContact = false;
  public contactUrl = 'https://ssl.help.tsite.jp/helpdesk?category_id=3365&site_domain=qa-tsite';
  public contactParams = {
    tcm_service: 'Tくじ',
    tcm_useragent: '',
    tcm_error_code: '',
    tcm_anken_id: '',
  };
  public viewMaintenance = false;
  public maintenanceUrl = environment.production
    ? 'https://web.tsite.jp/maintenance/lj/index.html'
    : 'https://stg.web.tsite.jp/maintenance/lj/index.html';
  public netId: string;

  constructor(
    private router: Router,
    private storeService: StoreService,
  ) { }

  ngOnInit() {
    this.urlParams = this.storeService.get('urlParams');

    const maintenanceCode = ['02-05', '04-05', '06-05', '08-05', '10-05', '12-05', '14-05'];

    const url = location.href.split('?')[0];
    this.contactParams.tcm_anken_id = url.split('/').slice(-1)[0];
    this.contactParams.tcm_error_code = this.error.message.match(/\d+-\d+/g)[0];
    this.contactParams.tcm_useragent = window.navigator.userAgent;

    if (Number(this.contactParams.tcm_error_code.split('-')[0]) <= 4) {
      this.viewContact = true;
    }

    if (maintenanceCode.includes(this.contactParams.tcm_error_code)) {
      this.viewContact = false;
      this.viewMaintenance = true;
    }
  }

  // TOPへ戻る
  public redirectTop(): void {
        /**
     * 現在のurlが ["/"] （お知らせ一覧）の場合、ページリロード
     */
    if (this.router.url.split('?')[0] === '/') {
      // ページリロード
      location.reload();
      return;
    }

    /**
     * それ以外はお知らせ一覧ページに遷移
     */
    this.router.navigate(['/'], { queryParams: this.urlParams });
  }

  postLink(path: string, params, method: string = 'post'): void {
    const $form = document.createElement('form');
    $form.id = 'post-link';
    $form.method = method;
    $form.action = path;
    $form.target = '_blank';

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const $hiddenField = document.createElement('input');
        $hiddenField.type = 'hidden';
        $hiddenField.name = key;
        $hiddenField.value = params[key];

        $form.appendChild($hiddenField);
      }
    }

    document.body.appendChild($form);
    $form.submit();

    $form.remove();
  }
}
